import tokens from './light';

export default tokens;
